<template>
  <v-dialog
    v-model="mutableEditDataDialog"
    max-width="750"
    persistent
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs12>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="close()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <AddFamilyForm
          v-if="mutableEditDataDialog"
          ref="form"
          :internal="false"
          edit
          :show-province="false"
        />
        <v-layout
          v-if="isFormValid === false"
          mb-0
          mt-3
        >
          <v-flex>
            <div class="v-message text-xs-center">
              <div class="v-messages__message">
                {{ $t('errors.form_not_valid') }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout
          justify-end
          :justify-center="$vuetify.breakpoint.xsOnly"
        >
          <v-flex shrink>
            <v-btn
              id="editFamilyData"
              color="sz_violet"
              class="text-xs-center"
              :loading="isLoad"
              @click="editFamilyData()"
            >
              {{ $t('buttons.save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AddFamilyForm from '@/components/addFamily/AddFamilyForm';
import validationRules from '@/constants/validationRules';

import { mapFields } from 'vuex-map-fields';

export default {
    name: 'EditFamilyDataModal',
    components: { AddFamilyForm },
    props: {
        editDataDialog: {
            type: Boolean
        },
        family: {
            type: Object,
            required: true
        },
        privileged: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            mutableEditDataDialog: false,
            validationRules,
            isFormValid: true,
            isLoad: false,
            checkNoNumber: false,
            emittedNoNumber: false
        };
    },
    computed: {
        ...mapFields('familyData', [
            'familyFormData.first_name',
            'familyFormData.last_name',
            'familyFormData.street',
            'familyFormData.building_number',
            'familyFormData.flat_number',
            'familyFormData.city',
            'familyFormData.postal_code',
            'familyFormData.phones',
            'no_street'
        ])
    },
    watch: {
        family: {
            handler (val) {
                this.first_name = val.first_name;
                this.last_name = val.last_name;
                this.street = val.street;
                this.building_number = val.building_number;
                this.flat_number = val.flat_number;
                this.city = val.city;
                this.postal_code = val.postal_code;
                this.phones = val.phones;
                if (val.phones.length === 0) {
                    this.checkNoNumber = true;
                }
                if (this.street == null) {
                    this.no_street = true;
                }
            },
            immediate: true,
            deep: true
        },
        editDataDialog (val, oldVal) {
            if (val !== oldVal) this.mutableEditDataDialog = this.editDataDialog;
        }
    },
    created () {
        this.$store.dispatch('provinces/getProvinces');
    },
    methods: {
        editFamilyData () {
            this.isLoad = true;
            this.validate().then((result) => {
                this.isFormValid = result;
                if (result) {
                    this.$store
                        .dispatch('familyData/editFamilyData', {
                            familyEditionId: this.family.family_edition_id,
                            privileged: this.privileged
                        })
                        .then(() => {
                            this.close();
                            this.clearData();
                            this.$emit('reload');
                        })
                        .finally(() => {
                            this.isLoad = false;
                        });
                } else {
                    this.isLoad = false;
                }
            });
        },
        validate () {
            return this.$refs.form.validate();
        },
        close () {
            this.$emit('close');
            if (this.emittedNoNumber) {
                this.isFormValid = true;
            }
        },
        clearData () {
            this.$store.commit('familyData/clearFormData');
        }
    }
};
</script>

<style scoped></style>
